var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.classes,style:(_vm.style),attrs:{"data-components":"ChevronRightSvg","xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }